import { Layout, Spin } from 'antd';
import { Suspense } from 'react';
import { Outlet, useMatch } from 'react-router';

import { EmptySection } from '@/components';
import { ROUTES } from '@/constants';
import { useApp, useFeatureFlags } from '@/contexts';

import './styles.scss';

import Sidebar from '../Sidebar';
import Topbar from '../Topbar';

const { Header, Content, Sider } = Layout;

const AppLayout = () => {
  const { selectedRegion, selectedCropSeason, hasCropSeasons, isLoadingScope } =
    useApp();

  const { isEnabled } = useFeatureFlags();
  const isCropSeasonSelectionEnabled = isEnabled(
    'releaseWebTopbarCropSeasonSelection'
  );

  const isSeasonsManagementRoute = Boolean(
    useMatch({
      path: `${ROUTES.REGION}/${ROUTES.SEASONS_MANAGEMENT}`,
      end: true
    })
  );
  const scopeKey = `${selectedRegion}:${selectedCropSeason}`;
  const hasUnselectedCropSeason =
    isCropSeasonSelectionEnabled &&
    !selectedCropSeason &&
    !isSeasonsManagementRoute;
  const showNoCropSeasonEmptyState =
    hasUnselectedCropSeason && hasCropSeasons === false && !isLoadingScope;
  const showCropSeasonLoadingState =
    hasUnselectedCropSeason && (isLoadingScope || hasCropSeasons === undefined);
  const showSelectCropSeasonPrompt =
    hasUnselectedCropSeason && hasCropSeasons === true && !isLoadingScope;

  let routeContent = <Outlet key={scopeKey} />;

  if (showNoCropSeasonEmptyState) {
    routeContent = (
      <div className='panorama-layout-centered-state'>
        <EmptySection
          title='No crop seasons in this region'
          description='Select a region with crop seasons to display the information.'
        />
      </div>
    );
  } else if (showCropSeasonLoadingState) {
    routeContent = (
      <div className='panorama-layout-centered-state'>
        <Spin size='large' />
      </div>
    );
  } else if (showSelectCropSeasonPrompt) {
    routeContent = (
      <div className='panorama-layout-centered-state'>
        <EmptySection
          title='Select a crop season'
          description='Select a crop season from the topbar to display the information.'
        />
      </div>
    );
  }

  return (
    <Layout>
      <Header>
        <Topbar />
      </Header>
      <Layout>
        <Sider width='auto' collapsedWidth='auto' trigger={null}>
          <Sidebar />
        </Sider>
        <Content>
          <Suspense fallback=''>{routeContent}</Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
